// extracted by mini-css-extract-plugin
export default {"hanchan":"Hanchan_hanchan__uOjJK","finished":"Hanchan_finished__0haiJ","hilightedPlayer":"Hanchan_hilightedPlayer__j1RO9","clickable":"Hanchan_clickable__ICkAS"};